import { Component} from '@angular/core';
import { GeneralExamComponent } from '../../General/g-exam.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TopicService } from '../topic.service';
import { Location } from '@angular/common';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-exam',
  templateUrl: './exam.component.html',
  styleUrls: ['../../General/tiles.css','./exam.component.css']
})
export class ExamComponent extends GeneralExamComponent {

  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService, protected _location: Location, protected router: Router, protected modalService: NgbModal) {
    super(activatedRoute, topicService, _location, router, modalService);
  }


  /** sets the type specific information */
  setTypeSpecificsFromConfiguration(){
    this.description = this.configuration.description;
  }
}

